export const instructionQuips = [
  "Estimate the cost of achieving cross-functional synergy.",
  "Uncover the price of strategic misalignment... again.",
  "Let’s circle back — but this time with a budget.",
  "Quantify the impact of ideating at scale.",
  "See how much ‘touching base’ really costs.",
  "Calculate the burn rate of your alignment ceremony.",
  "Put a price on your stakeholder engagement rituals.",
  "Measure the cost of ‘visibility’ in real time.",
  "Find out what your ‘low-lift check-in’ actually lifted.",
  "Translate buzzwords into budget burn 🔥",
];


export const getRandomInstruction = () =>
  instructionQuips[Math.floor(Math.random() * instructionQuips.length)];
